export const commonMuiSpacing = 3;
